<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-b gap-10">
        <button
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="ac-header">
          Schedule
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div>
        <div
          v-if="!scheduledStatus.includes(actionRequest.serviceStatus)"
          class="grid-column jc-s start gap-10"
        >
          <img
            src="@shared/assets/img/general/svg/calendar.svg"
            alt="calendar"
          >
          <div>
            <div class="sac__font-14 n70 semi-bold">
              Requested Date:
              <span class="sac__font-14 n70 reg">
                {{ getServiceDate(actionRequest.requestedDate, actionRequest.requestedTimes) }}
              </span>
            </div>
            <div class="sac__font-14 n70 semi-bold margin-top-8">
              Backup Date:
              <span class="sac__font-14 n70 reg">
                {{ getServiceDate(actionRequest.additionalDate, actionRequest.additionalTimes) }}
              </span>
            </div>
          </div>
        </div>
        <div class="grid-column reverse-auto ai-c gap-16 margin-top-8">
          <div class="grid-column ai-c jc-s gap-10">
            <img
              src="@shared/assets/img/general/svg/file.svg"
              alt="file"
            >
            <div class="sac__font-14 n70 semi-bold">
              Request Category:
            </div>
          </div>
          <SACDropdown
            :options="serviceCategoryList"
            :value="actionRequest.serviceCategory"
            placeholder="Select Service Category"
            field="serviceCategory"
            optionLabel="category"
            optionValue="category"
            :change="changeCurrentSR"
          />
        </div>
        <div class="grid-column reverse-auto ai-c gap-16 margin-top-16">
          <div class="grid-column ai-c jc-s gap-16">
            <img
              src="@shared/assets/img/general/svg/file.svg"
              alt="file"
            >
            <div class="sac__font-14 n70 semi-bold">
              Request Type:
            </div>
          </div>
          <div
            v-if="loadingVisitType"
          >
            <img src="@shared/assets/img/general/loading.svg">
          </div>
          <SACDropdown
            v-else
            :options="visitTypeList"
            :value="actionRequest.serviceType"
            placeholder="Select Service Type"
            field="serviceType"
            optionLabel="title"
            optionValue="visitType"
            :change="changeCurrentSR"
          />
        </div>
        <div class="grid-column jc-s ai-c gap-10 margin-top-16">
          <img
            src="@shared/assets/img/general/svg/edit.svg"
            alt="edit"
          >
          <div class="sac__font-14 n70 semi-bold">
            Customer Notes:
          </div>
          <div class="sac__font-14 n70">
            {{ actionRequest.customerNotes || '--' }}
          </div>
        </div>
      </div>
      <div class="margin-top-24">
        <div class="sac__font-18">
          Issues reported:
        </div>
        <div
          v-if="loadingCondition"
        >
          <img src="@shared/assets/img/general/loading.svg">
        </div>
        <div
          v-else-if="serviceIssueList.length"
          class="grid-column even"
        >
          <div
            v-for="(item, idx) in serviceIssueList"
            :key="idx"
            class="margin-top-8 sac__font-14"
          >
            <SACCheckbox
              :label="item.condition"
              :change="() => updateServiceIssue(item.condition, item.checked)"
              :checked="item.checked"
            />
          </div>
        </div>
        <div v-else-if="!loadingCondition && !issueList.length">
          --
        </div>
      </div>
      <div class="grid-column even gap-20 margin-top-24">
        <div class="ac-input-container">
          <div class="sac__font-18 mb-2">
            Schedule Date:
          </div>
          <DatePicker
            class="match-background"
            :value="actionRequest.scheduleDate"
            :minDate="today"
            @input="changeCurrentSR('scheduleDate', $event)"
          />
          <div
            v-if="errorObj.confirmedDateErr"
            class="sac__font-14 med tomato"
          >
            {{ errorObj.confirmedDateErr }}
          </div>
        </div>
        <div class="ac-input-container">
          <div class="sac__font-18 mb-2">
            Schedule Time:
          </div>
          <SACDropdown
            :options="confirmedTimeOp"
            :value="actionRequest.scheduleTime"
            placeholder="Select Time"
            field="scheduleTime"
            :change="changeCurrentSR"
            :error="errorObj.confirmedTimeErr"
          />
        </div>
      </div>
      <div class="ac-input-container margin-top-24">
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-18 med margin-bottom-4">
            Technician
            <span class="sac__font-12">(Optional):</span>
          </div>
          <!--          <button-->
          <!--            v-if="adminRole === 'admin'"-->
          <!--            class="sac__font-14 semi-bold f-primary"-->
          <!--            @click="addTechnician"-->
          <!--          >-->
          <!--            + Add technician-->
          <!--          </button>-->
        </div>
        <SACDropdown
          placeholder="Select Tech"
          searchParameter="label"
          field="assignedTechId"
          :options="getTechOptions(actionRequest.corpId)"
          :value="actionRequest.assignedTechId"
          :change="changeCurrentSR"
        />
      </div>
      <div class="ac-input-container margin-top-24">
        <div class="sac__font-18 mb-2">
          Job Value
          <span class="sac__font-12">(Optional):</span>
        </div>
        <SACInput
          field="serviceCost"
          type="number"
          placeholder="Enter $ estimate here.."
          :value="actionRequest.serviceCost"
          :change="changeCurrentSR"
        />
      </div>
      <div class="ac-input-container margin-top-24">
        <div class="sac__font-18 mb-2">
          Notes
          <span class="sac__font-12">(Optional):</span>
        </div>
        <textarea
          placeholder="Leave a note here..."
          :value="actionRequest.actionNote"
          @change="changeCurrentSR('actionNote', $event.target.value)"
        />
        <div class="sac__font-14">
          500 character max
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        @click="handleSubmit"
      >
        Submit
      </button>
    </div>
    <ProcessOverlay
      :show="processingAction"
      text="Updating service request"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import moment from 'moment';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import DatePicker from '@shared/components/DatePicker.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import serviceMixin from '@shared/mixins/serviceMixin';
import ActionStatus from '@shared/lib/constant/ActionStatus';

export default {
  name: 'ServiceRequestForm',
  components: {
    SACCheckbox,
    SACInput,
    SACDropdown,
    DatePicker,
    ProcessOverlay,
  },
  mixins: [serviceMixin],
  data() {
    return {
      show: false,
      today: new Date(moment().add(1, 'days').format('YYYY-MM-DD')),
      errorObj: {},
    };
  },
  computed: {
    serviceIssueList() {
      const existingIssue = this.actionRequest.serviceIssues;
      let updatedIssueList = [...this.issueList];
      if (existingIssue) {
        const existingIssueList = existingIssue.split(',');
        updatedIssueList = this.issueList.map((i) => {
          const updated = { ...i };
          if (existingIssueList.includes(i.condition)) {
            updated.checked = true;
          }
          return updated;
        });
      }
      return updatedIssueList;
    },
  },
  watch: {
    'actionRequest.serviceType': function () {
      this.getConditionList(this.actionRequest.serviceCategory, this.actionRequest.serviceType);
    },
  },
  mounted() {
    const {
      serviceCategory,
      serviceType,
    } = this.actionRequest;
    this.getServiceCategoryList();
    this.getVisitTypeList(serviceCategory);
    this.getConditionList(serviceCategory, serviceType);
    this.getTechList();
  },
  methods: {
    getServiceDate(date, time) {
      if (date && time) {
        return `${moment(date).format('MMM DD')}, ${time}`;
      }
      return '--';
    },
    updateServiceIssue(issue, checked) {
      const { serviceIssues } = this.actionRequest;
      let updatedServiceIssues;
      if (checked) {
        const list = serviceIssues.split(',');
        const updatedList = list.filter((item) => item !== issue);
        updatedServiceIssues = updatedList.join(',');
      } else {
        updatedServiceIssues = serviceIssues ? `${serviceIssues},${issue}` : issue;
      }
      this.$store.dispatch('changeCurrentSRValue', {
        field: 'serviceIssues',
        value: updatedServiceIssues,
      });
    },
    changeCurrentSR(field, value) {
      const updated = { ...this.actionRequest };
      updated[field] = value;
      this.$store.dispatch('changeServiceValue', {
        field: 'actionRequest',
        value: updated,
      });
    },
    async handleSubmit() {
      const {
        scheduleDate,
        scheduleTime,
      } = this.actionRequest;
      const errorObj = {};
      if (!scheduleDate) {
        errorObj.confirmedDateErr = 'Select schedule date';
      }
      if (!scheduleTime) {
        errorObj.confirmedTimeErr = 'Select schedule time';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.actionRequest.actionStatus = ActionStatus.Scheduled;
        if (this.actionRequest.jobId) {
          await this.$store.dispatch('updateServiceJob', this.actionRequest);
        } else {
          await this.$store.dispatch('updateServiceRequest', this.actionRequest);
        }
        this.toggleActionModal(false);
      }
    },
  },
};
</script>
